import React from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';

const Settings = () => {
  const location = useLocation();
  const isProfile = location.pathname === '/tenant/settings';
  const isDocument = location.pathname === '/tenant/settings/document';
  const isChangePassword = location.pathname === '/tenant/settings/change-password';
  const isBackgroundCheck = location.pathname === '/tenant/settings/background-check';

  return (
    <div className="settings-page">
      <div className="settings-content">
        <div className="settings-navigation">
          <Link
            to="/tenant/settings"
            className={`settings-nav-item ${isProfile ? 'active' : ''}`}
          >
            <span className="settings-nav-label">Profile</span>
            <img 
              src={window.getPublicUrl ? window.getPublicUrl("/assets/images/ArrorRighticon.svg") : "/assets/images/ArrorRighticon.svg"} 
              alt="arrow" 
              className="settings-nav-arrow-icon"
            />
          </Link>
          <Link
            to="/tenant/settings/document"
            className={`settings-nav-item ${isDocument ? 'active' : ''}`}
          >
            <span className="settings-nav-label">Document</span>
            <img 
              src={window.getPublicUrl ? window.getPublicUrl("/assets/images/ArrorRighticon.svg") : "/assets/images/ArrorRighticon.svg"} 
              alt="arrow" 
              className="settings-nav-arrow-icon"
            />
          </Link>
          <Link
            to="/tenant/settings/change-password"
            className={`settings-nav-item ${isChangePassword ? 'active' : ''}`}
          >
            <span className="settings-nav-label">Change Password</span>
            <img 
              src={window.getPublicUrl ? window.getPublicUrl("/assets/images/ArrorRighticon.svg") : "/assets/images/ArrorRighticon.svg"} 
              alt="arrow" 
              className="settings-nav-arrow-icon"
            />
          </Link>
          <Link
            to="/tenant/settings/background-check"
            className={`settings-nav-item ${isBackgroundCheck ? 'active' : ''}`}
          >
            <span className="settings-nav-label">Background Check</span>
            <img 
              src={window.getPublicUrl ? window.getPublicUrl("/assets/images/ArrorRighticon.svg") : "/assets/images/ArrorRighticon.svg"} 
              alt="arrow" 
              className="settings-nav-arrow-icon"
            />
          </Link>
        </div>

        <Outlet />
      </div>
    </div>
  );
};

export default Settings;
